<button [type]="buttonType" (click)="click()">
  <ng-content></ng-content>
</button>
